export default __webpack_public_path__ + "static/logo-118fe42f3b5f4981b55f9ff979f1f96c.png";